import { LOGGER_URL, PERMANENT_COOKIE_NAME } from 'constants/index';
import { cookies } from 'utils/cookies/cookies';
import { windowUtils } from 'utils/windowUtils/windowUtils';
import { HEAP_APP_ID, HEAP_ENVS } from '../../../constants/heap';

const DEFAULT_SCRIPT_ID = 'heap';

const getFetchOptions = payload => {
  const body = JSON.stringify(payload);
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const method = 'POST';

  return { body, headers, method };
};

const log = id => {
  fetch(
    LOGGER_URL,
    getFetchOptions({
      id: `CHECKOUT_${id}`,
      peerTrackerId: cookies.read(PERMANENT_COOKIE_NAME),
      cookiesEnabled: navigator.cookieEnabled,
    }),
  );
};

class Heap {
  static getHeapScript(id) {
    return `
    window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
    heap.load("${id}", { secureCookie: true });
    `;
  }

  static getHeapId() {
    return HEAP_ENVS.includes(windowUtils.getHostname())
      ? HEAP_APP_ID
      : undefined;
  }

  static initialize() {
    const id = this.getHeapId();

    if (!id) {
      throw new Error('You need to provide your Heap Analytics ID.');
    }

    if (!document) {
      return;
    }

    const hasScript = !!document.getElementById(DEFAULT_SCRIPT_ID);

    if (hasScript) {
      return;
    }

    if (window.heap) {
      log('[PAAR-4486] window.heap is defined');
    }

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.innerHTML = this.getHeapScript(id);
    script.id = DEFAULT_SCRIPT_ID;
    script.async = true;

    document.body.appendChild(script);
  }
}

export { Heap };
